import { includes, isUndefined, pick, remove } from 'lodash-es';
import { createSelector } from 'reselect';

import { CompanyStatus } from '../../common/constants';
import { getConfig } from '../../config';
import { getSessionCompanyId } from '../../selectors/session';
import { getUserCompanies } from '../../selectors/user';
import { isJobMetricsEnabledForCountry } from '../JobMetricsV1/hooks/useIsJobMetricsEnabled';
import { MENU_ITEMS, TALENT_HUNT } from './Constants';
import { FEATURES } from './Features';
import { CUSTOM_PERMISSIONS } from './Permissions';

export const getPlatformFeatures = state => state.platform.features.value;
function getSessionUserCompany(state) {
  const userCompanies = getUserCompanies(state);
  const sessionCompanyId = getSessionCompanyId(state);
  return userCompanies.find(company => company.id === sessionCompanyId);
}
export const getMenuItems = state => {
  const menuItems = state?.platform?.features?.value?.menuItems ?? [];

  const sessionUserCompany = getSessionUserCompany(state);

  const employerATSEnabled = !isUndefined(
    state?.entities?.features?.empEmployerATS
  );

  const isJobMetricsEnabled = isJobMetricsEnabledForCountry(
    sessionUserCompany?.CountryCode
  );

  const result = menuItems.filter(
    item =>
      !(
        employerATSEnabled ? ['applications', 'recommendations'] : ['eats']
      ).includes(item.value)
  );

  const { FEATURE_ENABLED_FOR_COUNTRIES } = getConfig();
  const isCVFinderEnabledCountry = includes(
    FEATURE_ENABLED_FOR_COUNTRIES.cvFinder,
    sessionUserCompany?.CountryCode
  );
  if (!isCVFinderEnabledCountry) {
    remove(result, item => [MENU_ITEMS.cvFinder.value].includes(item.value));
  }

  const isFeaturesPageEnabledCountry = includes(
    FEATURE_ENABLED_FOR_COUNTRIES.featuresPage,
    sessionUserCompany?.CountryCode
  );
  if (!isFeaturesPageEnabledCountry) {
    remove(result, item => [MENU_ITEMS.features.value].includes(item.value));
  }

  if (
    !isJobMetricsEnabled ||
    sessionUserCompany?.status !== CompanyStatus.VERIFIED
  ) {
    remove(result, item => [MENU_ITEMS.analytics.value].includes(item.value));
  }

  return result;
};

export const getPlatformFeatureNames = state => state.platform.features.names;
export const hasPlatformFeatureName = (state, name) =>
  state.platform.features.names.includes(name);
export const getFeatureSet = name => FEATURES[name] || null;

export const getMergePermissionsStates = state =>
  pick(state.platform.permissions, ['loading', 'success', 'error']);
export const getPermissions = state => state.platform.permissions.value;
export const getCustomPermissionsSet = name => CUSTOM_PERMISSIONS[name] || null;
export function authorizeCheck(activity, role, permissions) {
  if (permissions[activity]) {
    if (role && activity) {
      role = role.toUpperCase();
      return permissions[activity][role] || false;
    }
  }
  return false;
}
export const getIsTalentHuntApproved = createSelector(
  [getPlatformFeatureNames],
  platformFeatureName => platformFeatureName.includes(TALENT_HUNT)
);
